const RAW_CLIENT_EVENT_API_URL = import.meta.env.VITE_CLIENT_EVENT_API_URL || '/api/client-event/';
const CLIENT_EVENT_API_URL = RAW_CLIENT_EVENT_API_URL.endsWith('/') ? RAW_CLIENT_EVENT_API_URL : `${RAW_CLIENT_EVENT_API_URL}/`;
const CLIENT_EVENT_TIMEOUT_MS = Number(import.meta.env.VITE_CLIENT_EVENT_TIMEOUT_MS || 4000);

export type ClientEventPayload = {
  sessionId?: string | null;
  eventType: string;
  leadName?: string | null;
  scorePercentage?: number | null;
  message?: string | null;
  payload?: Record<string, unknown> | null;
};

function getTimeoutSignal(timeoutMs: number): AbortSignal {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(new Error('timeout')), timeoutMs);
  controller.signal.addEventListener('abort', () => clearTimeout(timer), { once: true });
  return controller.signal;
}

export async function trackClientEvent(event: ClientEventPayload): Promise<void> {
  const body = JSON.stringify(event);

  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(CLIENT_EVENT_API_URL, blob)) {
        return;
      }
    }

    await fetch(CLIENT_EVENT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body,
      keepalive: true,
      signal: getTimeoutSignal(CLIENT_EVENT_TIMEOUT_MS)
    });
  } catch {
  }
}

